const STORAGE_KEY = 'client_trace_id'
const HEADER_NAME = 'x-trace-id-client'

/**
 * Generate a random trace ID (10 characters alphanumeric)
 * @returns {string}
 */
function generateTraceId() {
  const chars = '0123456789abcdefghijklmnopqrstuvwxyz'
  let result = ''
  for (let i = 0; i < 10; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return result
}

/**
 * Get or create client trace ID from localStorage
 * @returns {string}
 */
function getClientTraceId() {
  try {
    let traceId = localStorage.getItem(STORAGE_KEY)
    if (!traceId) {
      traceId = generateTraceId()
      localStorage.setItem(STORAGE_KEY, traceId)
    }
    return traceId
  } catch (error) {
    console.error('Failed to get client trace ID:', error)
    return generateTraceId()
  }
}

/**
 * Add trace ID header to axios request config
 * @param {object} config - axios request config
 */
export function addTraceIdHeader(config) {
  const traceId = getClientTraceId()
  if (traceId && !config.headers[HEADER_NAME]) {
    config.headers[HEADER_NAME] = traceId
  }
}
